import { GameElement } from "../../../../../models/field/GameElement";
import { WeaponType } from "../../../../../models/data/WeaponType";
import { BoosterType } from "../../../../../../../common/models/data/BoosterType";
import { IBoxRewardsConfiguration } from "./IBoxRewardsConfiguration";

export const BASE_BOX_REWARDS_CONFIGURATION: IBoxRewardsConfiguration = {
    [GameElement.BoosterBox]: [
        { min: 50, max: 100, chance: 0.35 },
        { type: BoosterType.Mine, min: 1, max: 1, chance: 0.25 },
        { type: BoosterType.Turret, min: 1, max: 1, chance: 0.1 },
        { type: BoosterType.Energy, min: 1, max: 1, chance: 0.15 },
        { type: BoosterType.Freeze, min: 1, max: 1, chance: 0.15 },
    ],
    [GameElement.HealBox]: [
        { min: 25, max: 40 }
    ],
    [GameElement.WeaponsBox]: [
        { type: WeaponType.Boomerang, min: 3, max: 5, chance: 0.6 },
        { type: WeaponType.Dynamite, min: 3, max: 5, chance: 0.4 }
    ]
}
